import { useQuery } from '@tanstack/react-query'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { getUserAccount } from '@/services/user-account.services'
import {
  PAYMENT_QUERY_KEYS,
  CACHE_STALE_TIME,
  CACHE_GC_TIME,
  QUERY_NETWORK_MODE,
} from '@/shared/constants/cache'
import type { UserAccount } from '@/shared/types/global.types'

export function useUserAccount(enabled: boolean = true) {
  return useQuery<UserAccount>({
    queryKey: PAYMENT_QUERY_KEYS.userAccount,
    queryFn: async () => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return getUserAccount(token)
    },
    enabled,
    staleTime: CACHE_STALE_TIME,
    gcTime: CACHE_GC_TIME,
    networkMode: QUERY_NETWORK_MODE,
  })
}
